<template>

  <div class="padded">
    <h1><i class="fa fa-floppy-disk" />&nbsp;Backup</h1>

    <el-collapse v-if="isManager()" v-model="menu" accordion>

      <el-collapse-item v-for="(b, index) in backups" v-if="canAccess(b.access ? b.access : '')" :key="index" :title="b.name" :name="b.menu">
        <el-row :gutter="22">
          <span v-for="(btn, ind) in b.buttons" :key="ind">
            <el-col v-if="(btn.access ? canAccess(btn.access) : true)" :sm="24" :md="12" :lg="8">
              <download-button
                :text="btn.label"
                cls-style="width: 100%;margin-top: 1em; margin-bottom: 1em;"
                :url="btn.export"
                :type="(btn.type ? btn.type: 'info')"
                :icon="'fa fa-' + (btn.icon ? btn.icon : 'download')"
                :rounded="(btn.rounded ? btn.rounded : true)"
                :disabled="(btn.disabled ? btn.disabled : false)" />
            </el-col>
          </span>
      </el-row>
      </el-collapse-item>

    </el-collapse>

    <el-alert v-else title="Insufficient Access Rights" description="You don't have access rights to backup data." show-icon :closable="false" />

  </div>

</template>

<script>

import DownloadButton from '@/components/atoms/files/DownloadButton'

export default {

  components: {
    DownloadButton
  },

  data () {
    return {
      menu: 'projects',
      backups: [
        {
          name: 'Sites & Projects',
          menu: 'projects',
          access: 'project|maintenance|finance|management',
          buttons: [
            {label: 'Sites', icon: 'tower-cell', type: 'success', export: 'export/sites'},
            {label: 'Sites Stats', icon: 'line-chart', type: 'success', export: 'export/sites/stats'},
            {label: 'Site Backhaul Customers', icon: 'wifi', type: 'info', export: 'export/table/vw_site_backhaul_customers'},
            {label: 'Sharers', icon: 'users', type: 'primary', export: 'export/sharers'},
            {label: 'Equipment', icon: 'cogs', type: 'info', export: 'export/table/vw_assets'},
            {label: 'Structures', icon: 'tower-cell', type: 'warning', export: 'export/assets/structures'},
            {label: 'Backhaul Summary Report', icon: 'wifi', type: 'danger', export: 'export/table/vw_backhaul_report'},
            {label: 'Site Group Stats', icon: 'table', type: 'danger', export: 'export/table/vw_sitegroup_stats'},
            {label: 'Site Group Report', icon: 'table', type: 'danger', export: 'export/table/vw_sitegroup_report'},
            {label: 'Sharer Analysis', icon: 'users', type: 'danger', export: 'export/table/vw_sharer_analysis'},
            {label: 'Sharer Stats', icon: 'users', type: 'danger', export: 'export/table/vw_sharer_stats'},
            {label: 'Sharer Report', icon: 'users', type: 'danger', export: 'export/table/vw_occupancy'},
            {label: 'Sharer by Year', icon: 'users', type: 'danger', export: 'export/table/vw_occupancy_year'},
            {label: 'Structure Report', icon: 'sitemap', type: 'danger', export: 'export/table/vw_structure_report'},
            {label: 'Tower Supplier Report', icon: 'tower-cell', type: 'danger', export: 'export/table/vw_tower_supplier_report'},
            {label: 'Roll Out Report', icon: 'line-chart', type: 'danger', export: 'export/table/vw_rollout_report'},
            {label: 'Ways Summary', icon: 'arrow-up-9-1', type: 'danger', export: 'export/table/vw_occupancy_summary'},
          ]
        },
        {
          name: 'Requests',
          menu: 'requests',
          access: 'project|finance|management',
          buttons: [
            {label: 'Share', icon: 'share-alt', type: 'success', export: 'export/table/export_actions/actionType/rts'},
            {label: 'Upgrade', icon: 'tools', type: 'primary', export: 'export/table/export_actions/actionType/rtu'},
            {label: 'Backhaul', icon: 'wifi', type: 'info', export: 'export/table/export_actions/actionType/rtb'},
            {label: 'Dismantle', icon: 'xmark', type: 'danger', export: 'export/table/export_actions/actionType/rtd'},
            {label: 'Calendar', icon: 'calendar', type: 'info', export: 'export/table/vw_calendar/category/requests'},
            {label: 'Request Summary', icon: 'share-alt', type: 'danger', export: 'export/table/vw_request_summary/actionType'},
            {label: 'Request Report', icon: 'share-alt', type: 'danger', export: 'export/table/vw_request_report/actionType'},
          ]
        },
        {
          name: 'Maintenance & Admin',
          menu: 'maintenance',
          access: 'maintenance|project|admin|management',
          buttons: [
            {label: 'Site Workflows', icon: 'broadcast-tower', type: 'success', export: 'export/table/site_workflow/parent_id'},
            {label: 'Master Workflows', icon: 'cogs', type: 'primary', export: 'export/table/workflow/parent_id'},
            {label: 'Permits', icon: 'calendar', type: 'info', export: 'export/table/vw_permits'},
            {label: 'Insurance', icon: 'shield', type: 'info', export: 'export/table/vw_site_insurance'},
            {label: 'Tickets', icon: 'wrench', type: 'warning', export: 'export/tickets', access: 'maintenance|project|admin'},
            {label: 'Tickets Calendar', icon: 'wrench', type: 'warning', export: 'export/table/vw_calendar/category/tickets'},
            {label: 'Progress', icon: 'list', type: 'info', export: 'export/table/export_actions/actionType/PRG'},
            {label: 'Tickets Summary', icon: 'wrench', type: 'danger', export: 'export/table/vw_ticket_summary'},
            {label: 'Workflow Report', icon: 'cogs', type: 'danger', export: 'export/table/vw_workflow_report'},
          ]
        },
        {
          name: 'Property',
          menu: 'property',
          access: 'finance|property|management',
          buttons: [
            {label: 'Tenancy', icon: 'home', type: 'success', export: 'export/table/tenancy'},
            {label: 'Calendar', icon: 'calendar', type: 'info', export: 'export/table/vw_calendar/category/tenancy'},
            {label: 'Landlord Summary Report', icon: 'street-view', type: 'danger', export: 'export/table/vw_landlord_report'},
            {label: 'Landlords Report', icon: 'street-view', type: 'danger', export: 'export/table/vw_property_details'},
            {label: 'Property Report', icon: 'business-time', type: 'danger', export: 'export/table/vw_property_report'},
            {label: 'Rentals Due Report', icon: 'asterisk', type: 'danger', export: 'export/table/vw_rentals_due_report'},
          ]
        },
        {
          name: 'Finance',
          menu: 'finance',
          access: 'finance|management',
          buttons: [
            {label: 'Invoices', icon: 'list', type: 'info', export: 'export/table/invoice_items/site_id'},
//            {label: 'Works Orders', icon: 'cogs', type: 'danger', export: 'export/works-orders'},
            {label: this.getUtilLabel() + ' Calendar', icon: 'calendar', type: 'primary', export: 'export/table/vw_calendar/category/utility'},
            {label: this.getUtilLabel(), icon: 'plug', type: 'primary', export: 'export/table/utility/site_id'},
            {label: 'Rentals Due Report', icon: 'asterisk', type: 'danger', export: 'export/table/vw_rentals_due_report'},
            {label: 'Finance Sharer Summary', icon: 'money-bill-alt', type: 'danger', export: 'export/table/vw_finance_summary'},
//            {label: 'Statement', icon: 'money-bill-alt', type: 'danger', export: 'export/table/vw_finance_statement'},
            {label: this.getUtilLabel() + ' Report', icon: 'plug', type: 'danger', export: 'export/table/vw_utility_sharing'}
          ]
        },
        {
          name: 'Organsiations',
          menu: 'orgs',
          access: 'finance|property|project|admin|management',
          buttons: [
            {label: 'Authorities', icon: 'bank', export: 'export/org/authority'},
            {label: 'Backhaul Providers', icon: 'wifi', export: 'export/org/backhaul'},
            {label: 'Contractors', icon: 'tools', type: 'warning', export: 'export/org/contractor'},
            {label: 'Insurers', icon: 'shield-alt', type: 'primary', export: 'export/org/insurer'},
            {label: 'Landlords', icon: 'home', type: 'success', export: 'export/org/landlord'},
            {label: 'Telcos', icon: 'users', type: 'primary', export: 'export/org/telco'},
            {label: 'Tower Suppliers', icon: 'tower-cell', type: 'success', export: 'export/org/tower supplier'},
            {label: 'Utilities', icon: 'plug', type: 'primary', export: 'export/org/utility'},
          ]
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// Backup.vue?623a5e73